import { auditDomain } from '@domain/audit/AuditDomainFactory';

// Context lưu tại module – được set bởi AuditContextSetter (user, location, owner)
let auditContext = {
  userId: '',
  userName: '',
  locationId: '',
  ownerId: '',
};

/**
 * Thiết lập ngữ cảnh cho audit log (gọi từ Layout khi user/location thay đổi).
 */
export function setAuditContext(userId, userName, locationId, ownerId) {
  auditContext = {
    userId: typeof userId === 'string' ? userId : '',
    userName: typeof userName === 'string' ? userName : '',
    locationId: locationId != null && locationId !== undefined ? String(locationId) : '',
    ownerId: typeof ownerId === 'string' ? ownerId : (userId || ''),
  };
}

/**
 * Ghi một bản ghi kiểm toán.
 */
export function createAuditLog(actionOrObject, severity, type, meta = {}) {
  const merchantId = auditContext.ownerId || auditContext.userId;
  if (!merchantId) return;

  let action = 'unknown';
  let logSeverity = severity || 'INFO';
  let logType = type;
  let logMeta = meta;

  if (actionOrObject && typeof actionOrObject === 'object') {
    action = actionOrObject.action || 'unknown';
    logSeverity = actionOrObject.severity || 'INFO';
    logType = actionOrObject.type || actionOrObject.module || action;
    logMeta = { 
      ...(actionOrObject.meta || {}),
      details: actionOrObject.details || '',
      module: actionOrObject.module || '',
      locationId: actionOrObject.locationId || null
    };
  } else {
    action = actionOrObject || 'unknown';
  }

  const useCase = auditDomain.getCreateSecurityLogUseCase();
  useCase.execute(merchantId, {
    userId: auditContext.userId,
    userName: auditContext.userName,
    locationId: auditContext.locationId || logMeta?.locationId || null,
    ownerId: merchantId,
    action: action,
    severity: logSeverity === 'CRITICAL' || logSeverity === 'WARNING' ? logSeverity : 'INFO',
    status: (logSeverity === 'CRITICAL' || logSeverity === 'WARNING') ? 'warning' : 'success',
    type: logType || action || 'unknown',
    meta: logMeta,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : ''
  }).catch(err => console.warn('[createAuditLog] execute error:', err));
}

/**
 * Lắng nghe bản ghi kiểm toán theo ownerId.
 */
export function listenAuditLogs(ownerId, callback, limitCount = 50) {
  if (!ownerId) {
    callback([]);
    return () => {};
  }
  const repo = auditDomain.getRepository();
  return repo.listenSecurityLogs(ownerId, (logs) => {
    // Map to the expected UI format if necessary
    callback(logs.map(l => ({
      ...l,
      user: l.userName // Compatibility
    })));
  }, limitCount);
}

/** Nhãn mức độ (Tiếng Việt) */
export const SEVERITY_LABELS = {
  CRITICAL: 'Nghiêm trọng',
  WARNING: 'Cảnh báo',
  INFO: 'Thông tin',
};

/** Nhãn hành động (Tiếng Việt) */
export const AUDIT_ACTION_LABELS = {
  void_order: 'Hủy hóa đơn',
  void_item: 'Xóa món',
  admin_pin_failure: 'Nhập sai mã PIN Quản trị',
  manager_pin_failure: 'Nhập sai mã PIN Quản lý (Hủy đơn)',
  financial_access: 'Truy cập Báo cáo P&L',
  data_export: 'Tải bản sao lưu',
  login: 'Đăng nhập',
  login_failed: 'Đăng nhập thất bại',
  login_new_location: 'Đăng nhập thiết bị lạ',
  logout: 'Đăng xuất',
  SUPPLIER_CREATE: 'Tạo Nhà cung cấp',
  SUPPLIER_UPDATE: 'Cập nhật Nhà cung cấp',
  SUPPLIER_DEBT_ADD: 'Ghi nợ Nhà cung cấp',
  SUPPLIER_PAYMENT: 'Thanh toán Nhà cung cấp',
  MENU_PRICE_CHANGE: 'Thay đổi Giá bán',
  MENU_UPDATE: 'Cập nhật Thực đơn',
  PROMOTION_CREATE: 'Tạo Khuyến mãi',
  PROMOTION_UPDATE: 'Cập nhật Khuyến mãi',
  PROMOTION_DELETE: 'Xóa Khuyến mãi',
  UPDATE_POS_CONFIG: 'Cập nhật Cấu hình',
  INVOICE_CONFIG_UPDATE: 'Cấu hình Hóa đơn',
  NEGATIVE_FEEDBACK: 'Khách hàng không hài lòng',
  CUSTOMER_ENSURE: 'Tự động tạo khách hàng',
  CUSTOMER_CREATE: 'Tạo khách hàng mới',
  CUSTOMER_UPDATE: 'Cập nhật khách hàng',
  CUSTOMER_DELETE: 'Xóa khách hàng'
};

